export default (value, digits = 2) => {
  return Intl.NumberFormat('lv-LV', {
    style: 'decimal',
    minimumFractionDigits: digits,
    useGrouping: true,
    maximumFractionDigits: 8
  })
    .format(value)
}
